import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HomePageComponent } from './home-page/home-page.component';
import { AppRoutingModule } from './/app-routing.module';
import { ListStepComponent } from './steps/list-step/list-step.component';
import { MessageContentComponent } from './steps/message-content/message-content.component';
import { MessageDropsComponent } from './steps/message-drops/message-drops.component';
import { MessageReportComponent } from './steps/message-report/message-report.component';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HomePageComponent,
    ListStepComponent,
    MessageContentComponent,
    MessageDropsComponent,
    MessageReportComponent,
  ],
  imports: [BrowserModule, AppRoutingModule],
  providers: [],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
